import Vue from "vue";
import Vuex from "vuex";
import events from "./modules/events";
import users from "./modules/users";
import attendees from "./modules/attendees";
Vue.use(Vuex);

export default function() {
  return new Vuex.Store({
    strict: true,
    state: {
      loading: false,
      userSession: null
    },
    mutations: {
      loading(state, v) {
        state.loading = v;
      }
    },
    modules: {
      events: events(),
      attendees: attendees(),
      users
    }
  });
}



// WEBPACK FOOTER //
// ./src/store/index.js